module.exports = __webpack_public_path__ + "img/42.5879c01a.jpg";